/* tslint:disable */
/* eslint-disable */
/**
 * Product Configurator Web API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter } from "tslib";
import * as runtime from '../runtime';
/**
 *
 */
export class ConfigurationApi extends runtime.BaseAPI {
    /**
     * Create a new sub-configuration.
     */
    addSubConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling addSubConfiguration.');
            }
            if (requestParameters.addSubConfigurationParams === null || requestParameters.addSubConfigurationParams === undefined) {
                throw new runtime.RequiredError('addSubConfigurationParams', 'Required parameter requestParameters.addSubConfigurationParams was null or undefined when calling addSubConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/subConfiguration`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.addSubConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Create a new sub-configuration.
     */
    addSubConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addSubConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Changes an existing configuration by selecting values and/or value quantifies.
     */
    changeConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling changeConfiguration.');
            }
            if (requestParameters.changeConfigurationParams === null || requestParameters.changeConfigurationParams === undefined) {
                throw new runtime.RequiredError('changeConfigurationParams', 'Required parameter requestParameters.changeConfigurationParams was null or undefined when calling changeConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/change`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.changeConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Changes an existing configuration by selecting values and/or value quantifies.
     */
    changeConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.changeConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Copy or move a sub-configuration.
     */
    changeSubConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling changeSubConfiguration.');
            }
            if (requestParameters.changeSubConfigurationParams === null || requestParameters.changeSubConfigurationParams === undefined) {
                throw new runtime.RequiredError('changeSubConfigurationParams', 'Required parameter requestParameters.changeSubConfigurationParams was null or undefined when calling changeSubConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/subConfiguration`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.changeSubConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Copy or move a sub-configuration.
     */
    changeSubConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.changeSubConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new configuration as a clone of the current configuration.
     */
    cloneConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling cloneConfiguration.');
            }
            if (requestParameters.cloneConfigurationParams === null || requestParameters.cloneConfigurationParams === undefined) {
                throw new runtime.RequiredError('cloneConfigurationParams', 'Required parameter requestParameters.cloneConfigurationParams was null or undefined when calling cloneConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/clone`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.cloneConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Create a new configuration as a clone of the current configuration.
     */
    cloneConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cloneConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Commits the configuration changes.
     */
    commitConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling commitConfiguration.');
            }
            if (requestParameters.getConfigurationParams === null || requestParameters.getConfigurationParams === undefined) {
                throw new runtime.RequiredError('getConfigurationParams', 'Required parameter requestParameters.getConfigurationParams was null or undefined when calling commitConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/commit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.getConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Commits the configuration changes.
     */
    commitConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.commitConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new configuration.
     */
    createConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createConfigurationParams === null || requestParameters.createConfigurationParams === undefined) {
                throw new runtime.RequiredError('createConfigurationParams', 'Required parameter requestParameters.createConfigurationParams was null or undefined when calling createConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.createConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Create a new configuration.
     */
    createConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete a configuration.
     */
    deleteConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a configuration.
     */
    deleteConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteConfigurationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Delete a sub-configuration.
     */
    deleteSubConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteSubConfiguration.');
            }
            if (requestParameters.deleteSubConfigurationParams === null || requestParameters.deleteSubConfigurationParams === undefined) {
                throw new runtime.RequiredError('deleteSubConfigurationParams', 'Required parameter requestParameters.deleteSubConfigurationParams was null or undefined when calling deleteSubConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/subConfiguration`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.deleteSubConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Delete a sub-configuration.
     */
    deleteSubConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSubConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the configuration assembly (2D or 3D).
     */
    getAssemblyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getAssembly.');
            }
            const queryParameters = {};
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            if (requestParameters.currencyId !== undefined) {
                queryParameters['currencyId'] = requestParameters.currencyId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/assembly`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the configuration assembly (2D or 3D).
     */
    getAssembly(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAssemblyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a static asset (e.g. image or PDF).
     */
    getAssetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.path === null || requestParameters.path === undefined) {
                throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling getAsset.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/assets/{path}`.replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get a static asset (e.g. image or PDF).
     */
    getAsset(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getAssetRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get the configuration BOM.
     */
    getBomRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getBom.');
            }
            const queryParameters = {};
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            if (requestParameters.currencyId !== undefined) {
                queryParameters['currencyId'] = requestParameters.currencyId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/bom`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the configuration BOM.
     */
    getBom(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getBomRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the configuration CADClick assembly (3D).
     */
    getCadClickAssemblyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCadClickAssembly.');
            }
            const queryParameters = {};
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            if (requestParameters.currencyId !== undefined) {
                queryParameters['currencyId'] = requestParameters.currencyId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/cadClickAssembly`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the configuration CADClick assembly (3D).
     */
    getCadClickAssembly(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCadClickAssemblyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get (GET over POST) configuration objects of an existing configuration.
     */
    getConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getConfiguration.');
            }
            if (requestParameters.getConfigurationParams === null || requestParameters.getConfigurationParams === undefined) {
                throw new runtime.RequiredError('getConfigurationParams', 'Required parameter requestParameters.getConfigurationParams was null or undefined when calling getConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.getConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get (GET over POST) configuration objects of an existing configuration.
     */
    getConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a list of all independent configuration objects (all objects available for configuration by the user).
     */
    getConfiguratorsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurators`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get a list of all independent configuration objects (all objects available for configuration by the user).
     */
    getConfigurators() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getConfiguratorsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a list of supported currencies for pricing and costs.
     */
    getCurrenciesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/currencies`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get a list of supported currencies for pricing and costs.
     */
    getCurrencies() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getCurrenciesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the configuration drawing (2D or 3D).
     */
    getDrawingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getDrawing.');
            }
            const queryParameters = {};
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            if (requestParameters.currencyId !== undefined) {
                queryParameters['currencyId'] = requestParameters.currencyId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/drawing`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the configuration drawing (2D or 3D).
     */
    getDrawing(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDrawingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the health status of the configuration server.
     */
    getHealthRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/health`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the health status of the configuration server.
     */
    getHealth(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHealthRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get API information of the configuration server.
     */
    getInfoRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/info`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get API information of the configuration server.
     */
    getInfo(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getInfoRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the layout definition to render a specific configuration object.
     */
    getLayoutsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.rootCfgObjectId === null || requestParameters.rootCfgObjectId === undefined) {
                throw new runtime.RequiredError('rootCfgObjectId', 'Required parameter requestParameters.rootCfgObjectId was null or undefined when calling getLayouts.');
            }
            if (requestParameters.cfgObjectId === null || requestParameters.cfgObjectId === undefined) {
                throw new runtime.RequiredError('cfgObjectId', 'Required parameter requestParameters.cfgObjectId was null or undefined when calling getLayouts.');
            }
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            if (requestParameters.rootCfgObjectId !== undefined) {
                queryParameters['rootCfgObjectId'] = requestParameters.rootCfgObjectId;
            }
            if (requestParameters.cfgObjectId !== undefined) {
                queryParameters['cfgObjectId'] = requestParameters.cfgObjectId;
            }
            if (requestParameters.layoutId !== undefined) {
                queryParameters['layoutId'] = requestParameters.layoutId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/layouts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the layout definition to render a specific configuration object.
     */
    getLayouts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLayoutsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a list of supported locales for configuration.
     */
    getLocalesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/locales`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get a list of supported locales for configuration.
     */
    getLocales() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getLocalesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Receive logs for the configuration (Web Socket or rest polling endpoint). Logging must be enabled for the configuration and development mode must be enabled for the server.
     */
    getLogsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getLogs.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/logs`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Receive logs for the configuration (Web Socket or rest polling endpoint). Logging must be enabled for the configuration and development mode must be enabled for the server.
     */
    getLogs(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLogsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a list of all configurable products.
     */
    getProductsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/products`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get a list of all configurable products.
     */
    getProducts() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getProductsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get load statistics of the configuration server.
     */
    getStatisticsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/statistics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get load statistics of the configuration server.
     */
    getStatistics(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStatisticsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get structured translations for a specific configuration object or all configuration objects.
     */
    getStructuredTranslationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/structuredTranslations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get structured translations for a specific configuration object or all configuration objects.
     */
    getStructuredTranslations() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getStructuredTranslationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the configuration summary.
     */
    getSummaryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getSummary.');
            }
            const queryParameters = {};
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            if (requestParameters.currencyId !== undefined) {
                queryParameters['currencyId'] = requestParameters.currencyId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/summary`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the configuration summary.
     */
    getSummary(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSummaryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * The getter must not have any side effects.
     * Get a table of the given configuration object by path.
     */
    getTableRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getTable.');
            }
            if (requestParameters.configurationTableParams === null || requestParameters.configurationTableParams === undefined) {
                throw new runtime.RequiredError('configurationTableParams', 'Required parameter requestParameters.configurationTableParams was null or undefined when calling getTable.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/table`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.configurationTableParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * The getter must not have any side effects.
     * Get a table of the given configuration object by path.
     */
    getTable(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTableRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the theme definition.
     */
    getThemesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            if (requestParameters.themeId !== undefined) {
                queryParameters['themeId'] = requestParameters.themeId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/themes`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the theme definition.
     */
    getThemes() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getThemesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a list of supported UI locales for configuration.
     */
    getUiLocalesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/uiLocales`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get a list of supported UI locales for configuration.
     */
    getUiLocales() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getUiLocalesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get UI translations for a specific UI context.
     */
    getUiTranslationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.localeId === null || requestParameters.localeId === undefined) {
                throw new runtime.RequiredError('localeId', 'Required parameter requestParameters.localeId was null or undefined when calling getUiTranslations.');
            }
            if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
                throw new runtime.RequiredError('contextId', 'Required parameter requestParameters.contextId was null or undefined when calling getUiTranslations.');
            }
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/uiTranslations/{localeId}/{contextId}`.replace(`{${"localeId"}}`, encodeURIComponent(String(requestParameters.localeId))).replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get UI translations for a specific UI context.
     */
    getUiTranslations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUiTranslationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all unit systems. This includes all units, unit groups and dimensions.
     */
    getUnitsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.releaseId !== undefined) {
                queryParameters['releaseId'] = requestParameters.releaseId;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/units`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get all unit systems. This includes all units, unit groups and dimensions.
     */
    getUnits() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getUnitsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Invoke a user defined function in as specific configuration object.
     */
    invokeUserDefinedFunctionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling invokeUserDefinedFunction.');
            }
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling invokeUserDefinedFunction.');
            }
            if (requestParameters.invokeUserDefinedFunctionParams === null || requestParameters.invokeUserDefinedFunctionParams === undefined) {
                throw new runtime.RequiredError('invokeUserDefinedFunctionParams', 'Required parameter requestParameters.invokeUserDefinedFunctionParams was null or undefined when calling invokeUserDefinedFunction.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/userDefinedFunction/{name}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.invokeUserDefinedFunctionParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Invoke a user defined function in as specific configuration object.
     */
    invokeUserDefinedFunction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.invokeUserDefinedFunctionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * The getter must not have any side effects.
     * Invoke a user defined getter in as specific configuration object.
     */
    invokeUserDefinedGetterRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling invokeUserDefinedGetter.');
            }
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling invokeUserDefinedGetter.');
            }
            if (requestParameters.invokeUserDefinedGetterParams === null || requestParameters.invokeUserDefinedGetterParams === undefined) {
                throw new runtime.RequiredError('invokeUserDefinedGetterParams', 'Required parameter requestParameters.invokeUserDefinedGetterParams was null or undefined when calling invokeUserDefinedGetter.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/userDefinedGetter/{name}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.invokeUserDefinedGetterParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * The getter must not have any side effects.
     * Invoke a user defined getter in as specific configuration object.
     */
    invokeUserDefinedGetter(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.invokeUserDefinedGetterRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Prevent the configuration from being garbage collected over time.
     */
    keepConfigurationAliveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling keepConfigurationAlive.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/keepAlive`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Prevent the configuration from being garbage collected over time.
     */
    keepConfigurationAlive(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.keepConfigurationAliveRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Restores a saved configuration from JSON.
     */
    loadConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling loadConfiguration.');
            }
            if (requestParameters.loadConfigurationParams === null || requestParameters.loadConfigurationParams === undefined) {
                throw new runtime.RequiredError('loadConfigurationParams', 'Required parameter requestParameters.loadConfigurationParams was null or undefined when calling loadConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/load`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.loadConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Restores a saved configuration from JSON.
     */
    loadConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.loadConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Fetch a new version of the KB and reload the configurator, only new configurations will be affected.
     */
    reloadRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/reload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Fetch a new version of the KB and reload the configurator, only new configurations will be affected.
     */
    reload(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reloadRaw(initOverrides);
        });
    }
    /**
     * Reset the configuration or a sub-configuration.
     */
    resetConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling resetConfiguration.');
            }
            if (requestParameters.resetConfigurationParams === null || requestParameters.resetConfigurationParams === undefined) {
                throw new runtime.RequiredError('resetConfigurationParams', 'Required parameter requestParameters.resetConfigurationParams was null or undefined when calling resetConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/reset`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.resetConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Reset the configuration or a sub-configuration.
     */
    resetConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.resetConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Reset a list of attributes to their default value.
     */
    resetConfigurationAttributesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling resetConfigurationAttributes.');
            }
            if (requestParameters.resetConfigurationAttributesParams === null || requestParameters.resetConfigurationAttributesParams === undefined) {
                throw new runtime.RequiredError('resetConfigurationAttributesParams', 'Required parameter requestParameters.resetConfigurationAttributesParams was null or undefined when calling resetConfigurationAttributes.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/resetAttributes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.resetConfigurationAttributesParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Reset a list of attributes to their default value.
     */
    resetConfigurationAttributes(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.resetConfigurationAttributesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rollback the configuration to the last commit.
     */
    rollbackConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling rollbackConfiguration.');
            }
            if (requestParameters.getConfigurationParams === null || requestParameters.getConfigurationParams === undefined) {
                throw new runtime.RequiredError('getConfigurationParams', 'Required parameter requestParameters.getConfigurationParams was null or undefined when calling rollbackConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/rollback`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.getConfigurationParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rollback the configuration to the last commit.
     */
    rollbackConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.rollbackConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Save the configuration as JSON.
     */
    saveConfigurationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling saveConfiguration.');
            }
            const queryParameters = {};
            if (requestParameters.localeId !== undefined) {
                queryParameters['localeId'] = requestParameters.localeId;
            }
            if (requestParameters.currencyId !== undefined) {
                queryParameters['currencyId'] = requestParameters.currencyId;
            }
            if (requestParameters.includeBom !== undefined) {
                queryParameters['includeBom'] = requestParameters.includeBom;
            }
            if (requestParameters.includeSummary !== undefined) {
                queryParameters['includeSummary'] = requestParameters.includeSummary;
            }
            if (requestParameters.includeSaveState !== undefined) {
                queryParameters['includeSaveState'] = requestParameters.includeSaveState;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/3pq-cs/v2/configuration/configurations/{id}/save`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Save the configuration as JSON.
     */
    saveConfiguration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveConfigurationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
//# sourceMappingURL=ConfigurationApi.js.map